import React from 'react';

import background1 from '../assets/images/main-slider/software-erp-development-hero.png';
import pattern5 from '../assets/images/background/pattern-5.png';
import pattern6 from '../assets/images/background/pattern-6.png'; 

const Technology = ({ }) => {
    return (
<>
<section className="technology-section" style={{ backgroundImage: `url(${background1})` }}>
      <div className="pattern-layer-one" style={{ backgroundImage: `url(${pattern5})` }}></div>
      <div className="pattern-layer-two" style={{ backgroundImage: `url(${pattern6})` }}></div>
		<div className="auto-container">
			<div className="row clearfix">
				{/* <!-- Title Column --> */}
				<div className="title-column col-lg-5 col-md-12 col-sm-12">
					<div className="inner-column">
						{/* <!-- Sec Title --> */}
						<div className="sec-title light">
							<div className="title">TECHNOLOGY INDEX</div>
							<h2>Trusted Tech Work That Helps You Build Strong and Simple Solutions</h2>
							 <div className="text" style={{ maxWidth: "360px", lineHeight: "1.65", marginTop: "15px" }}>
							We work with clear and steady tech tools that help your business grow without stress.
							Our team uses safe and tested methods for web, software, apps, and extensions.
							Every project is built with care so your work stays smooth, fast, and easy to manage.
							You get simple solutions that make your daily tasks lighter.
						</div>
						</div>
					</div>
				</div>
				{/* <!-- Blocks Column --> */}
				<div className="blocks-column col-lg-7 col-md-12 col-sm-12">
					<div className="inner-column">
						<div className="row clearfix">
							{/* <!-- Technology Block --> */}
							<div className="technology-block col-lg-4 col-md-6 col-sm-12">
								<div className="inner-box">
									<a href="/services/hire-chrome-extension-developer" className="overlay-link"></a>
									<div className="icon-box">
										<span className="flaticon-tv"></span>
									</div>
									<h6>Extensions</h6>
								</div>
							</div>

							{/* <!-- Technology Block --> */}
							<div className="technology-block col-lg-4 col-md-6 col-sm-12">
								<div className="inner-box">
									<a href="/services/web-development" className="overlay-link"></a>
									<div className="icon-box">
										<span className="flaticon-coding-2"></span>
									</div>
									<h6>WEB</h6>
								</div>
							</div>
							
							{/* <!-- Technology Block --> */}
							<div className="technology-block col-lg-4 col-md-6 col-sm-12">
								<div className="inner-box">
									<a href="/services/erp-development" className="overlay-link"></a>
									<div className="icon-box">
										<span className="flaticon-smartband"></span>
									</div>
									<h6>ERP Systems</h6>
								</div>
							</div>
							{/* <!-- Technology Block --> */}
							<div className="technology-block col-lg-4 col-md-6 col-sm-12">
								<div className="inner-box">
									<a href="/services/web-development" className="overlay-link"></a>
									<div className="icon-box">
										<span className="flaticon-iot"></span>
									</div>
									<h6>IT Soluations</h6>
								</div>
							</div>
							{/* <!-- Technology Block --> */}
							<div className="technology-block col-lg-4 col-md-6 col-sm-12">
								<div className="inner-box">
									<a href="/services" className="overlay-link"></a>
									<div className="icon-box">
										<span className="flaticon-android"></span>
									</div>
									<h6>ANDROID</h6>
								</div>
							</div>
							
							{/* <!-- Technology Block --> */}
							<div className="technology-block col-lg-4 col-md-6 col-sm-12">
								<div className="inner-box">
									<a href="/services" className="overlay-link"></a>
									<div className="icon-box">
										<span className="flaticon-apple"></span>
									</div>
									<h6>IOS</h6>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	{/* <!-- End Technology Section --> */}
</>
        );
    };
    
    export default Technology;
